import { ILabel } from '@/shared/models/api/labels-model';
import { LabelMapper } from '@/shared/mappings/label-mapper';

class LabelService {
    public labelMapper = new LabelMapper();

    constructor() {}

    public getLabelsByCategory(language: string, category: string, HttpService: any): Promise<any> {
        return this.labelService(this.getLabelsQuery(language, category), HttpService)
    }

    private labelService = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.getList(url).then((result: ILabel[]) => {
                let mappedResults = result.map((label: ILabel) => this.labelMapper.mapLabel(label))
                resolve(mappedResults);
            }).catch((error: any) => {
                reject(error)
            });
        })
    }
    
    private getLabelsQuery = (language: string, category: string): string => {
        return `/api/languages/${language}/categories/${category}/items`
    }
}

export default new LabelService();
